var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-c1cc0000-0000-0000-0000-c1cc00000000",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-c1cc0000-0000-0000-0000-c1cc00000001 {\n        fill: #2c2c2c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c1cc0000-0000-0000-0000-c1cc00000001",
    d: "M1248,96c52.94,0,96,43.06,96,96v1536c0,52.94-43.06,96-96,96H192c-52.94,0-96-43.06-96-96V192c0-52.94,43.06-96,96-96h1056M1248,0H192C85.96,0,0,85.96,0,192v1536c0,106.04,85.96,192,192,192h1056c106.04,0,192-85.96,192-192V192c0-106.04-85.96-192-192-192h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-c1cc0000-0000-0000-0000-c1cc00000001",
    d: "M965,791.2 A310,310 0 1,0 965,1128.8 L860.2,1060.8 A185,185 0 1,1 860.2,859.2 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCIcon);
export default __webpack_public_path__ + "static/media/CIcon.a9a8c304260e85f247d4f4fb4f7434c3.svg";
export { ForwardRef as ReactComponent };